import React from "react"
import "./layout.scss"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import Logo from "../images/logo.svg"
import { Sticky } from "react-sticky"
import { view } from "react-easy-state"
import playerStore from "./store"

const NavbarItem = (props) => {
  const { page } = props
  return (
    <Link
      onClick={props.toggleMenu}
      className="navbar-item is-uppercase has-text-weight-bold"
      to={page.slug === "home" ? "/" : `/${page.slug}`}
    >
      {page.title}
    </Link>
  )
}
const NavbarBurger = (props) => (
  <button
    onClick={props.toggleMenu}
    className={`button navbar-burger ${props.active ? "is-active" : ""}`}
  >
    <span />
    <span />
    <span />
  </button>
)

class Navbar extends React.Component {
  state = {
    activeMenu: false,
    showedFullPlayerFirstTime: false,
  }
  toggleMenu = () => {
    this.setState({
      activeMenu: !this.state.activeMenu,
    })
  }

  showMusicPlayer = () => {
    playerStore.mode = "full"
    this.setState({ showedFullPlayerFirstTime: true })
  }

  render() {
    const { pages = [] } = this.props
    const { allWpPage, allWpMenu } = pages
    
    // Finde das Hauptmenü (üblicherweise "primary" oder "main")
    const mainMenu = allWpMenu?.edges?.find(
      menu => menu.node.slug === 'primary' || menu.node.slug === 'main' || menu.node.name === 'Hauptmenü'
    )
    
    // Wenn ein Menü gefunden wurde, verwende es, sonst falle auf alle Seiten zurück
    let menuItems = []
    try {
      if (mainMenu && mainMenu.node.menuItems && mainMenu.node.menuItems.nodes) {
        // Sortiere nach der WordPress-Menüreihenfolge
        const sortedMenuItems = [...mainMenu.node.menuItems.nodes]
          .filter(item => !item.parentId) // Nur Haupt-Menüpunkte
          .sort((a, b) => (a.order || 999) - (b.order || 999))
        
        menuItems = sortedMenuItems.map(menuItem => {
          const label = menuItem.label || menuItem.connectedNode?.node?.title
          const path = menuItem.path || menuItem.connectedNode?.node?.slug
          
          return (
            <NavbarItem
              page={{
                id: menuItem.id,
                title: label,
                slug: path?.replace(/^\//, '').replace(/\/$/, '') // Entferne führende/nachfolgende Slashes
              }}
              key={menuItem.id}
              toggleMenu={this.toggleMenu}
            />
          )
        })
      } else {
        // Fallback: Verwendung aller Seiten
        const { edges } = allWpPage
        menuItems = edges
          .filter((e) => {
            const { node } = e
            return node.slug !== "datenschutzerklarung"
          })
          .sort((a, b) => a.node.title.localeCompare(b.node.title)) // Alphabetische Sortierung als Fallback
          .map((page) => {
            const { node } = page
            return (
              <NavbarItem page={node} key={node.id} toggleMenu={this.toggleMenu} />
            )
          })
      }
    } catch (error) {
      console.warn('Navigation error, using fallback:', error)
      // Letztes Fallback: Hardcode wichtige Seiten
      menuItems = [
        <NavbarItem page={{ id: '1', title: 'Bavegna', slug: 'bavegna' }} key="1" toggleMenu={this.toggleMenu} />,
        <NavbarItem page={{ id: '2', title: 'Uis', slug: 'uis' }} key="2" toggleMenu={this.toggleMenu} />,
        <NavbarItem page={{ id: '3', title: 'Programm', slug: 'programm' }} key="3" toggleMenu={this.toggleMenu} />,
      ]
    }
    const { activeMenu, showedFullPlayerFirstTime } = this.state

    return (
      <>
        <Sticky>
          {({ style }) => (
            <nav
              id="nav"
              style={{
                ...style,
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                borderRadius: '0 0 8px 8px',
              }}
              className="navbar is-spaced has-background-light"
            >
              <div className="navbar-brand">
                <Link to="/" className="navbar-item is-hidden-tablet">
                  <img src={Logo} width="40" height="40" alt="Logo CVBS" />
                </Link>
                <NavbarBurger
                  active={activeMenu}
                  toggleMenu={this.toggleMenu}
                />
              </div>
              <div className={`navbar-menu ${activeMenu ? "is-active" : ""}`}>
                <div className="navbar-start">{menuItems}</div>
                <div className="navbar-end">
                  {!showedFullPlayerFirstTime && (
                    <a
                      onClick={this.showMusicPlayer}
                      className="navbar-item is-uppercase has-text-weight-bold"
                    >
                      Lieder
                    </a>
                  )}
                  {/* <Link
                    to="/programm"
                    className="navbar-item is-uppercase has-text-weight-bold"
                  >
                    Programm
                  </Link> */}
                  {/* <Link
                    to="/galerie"
                    className="navbar-item is-uppercase has-text-weight-bold"
                  >
                    Galerie
                  </Link> */}
                  {/* <Link
                    to="/videos"
                    className="navbar-item is-uppercase has-text-weight-bold"
                  >
                    Videos
                  </Link> */}
                  {/* <Link to="/" className="navbar-item is-hidden-mobile">
                    <img src={Logo} width="40" height="40" alt="Logo CVBS" />
                  </Link> */}
                </div>
              </div>
            </nav>
          )}
        </Sticky>
      </>
    )
  }
}

Navbar.propTypes = {
  pages: PropTypes.object.isRequired,
  color: PropTypes.string,
}

export default view(Navbar)
